/**
 * eMerge's service lines.
 *
 * Taken from the company's own hero copy — "eMerge brings Dentistry, Podiatry,
 * Optometry, and Audiology directly to long-term care communities" — so the
 * list a conference visitor picks from is the list the website advertises.
 *
 * This mirrors PRACTICE_OPTIONS in backend/src/services/eventFunnelForm.js,
 * which is the authority: the server fills an empty dropdown, and the copy
 * here only lets the admin editor show the same choices before saving. A test
 * compares the two, because a silent divergence would mean the editor previews
 * choices the public form does not offer.
 */
export const PRACTICE_OPTIONS: string[] = [
  'Dentistry',
  'Podiatry',
  'Optometry',
  'Audiology',
  'All of the above',
];

export default PRACTICE_OPTIONS;
